var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15293_10429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00007 4.4445C8.36826 4.4445 8.66673 4.74299 8.66672 5.11118L8.66667 8.22229C8.66666 8.59048 8.36818 8.88895 7.99999 8.88894C7.6318 8.88894 7.33333 8.59045 7.33334 8.22226L7.33339 5.11115C7.3334 4.74296 7.63188 4.44449 8.00007 4.4445Z",
    fill: "#F89500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88894 10.6667C8.88894 11.1576 8.49097 11.5556 8.00005 11.5556C7.50913 11.5556 7.11117 11.1576 7.11117 10.6667C7.11117 10.1758 7.50913 9.77783 8.00005 9.77783C8.49097 9.77783 8.88894 10.1758 8.88894 10.6667Z",
    fill: "#F89500"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2223 8.00005C14.2223 11.4365 11.4365 14.2223 8.00005 14.2223C4.56362 14.2223 1.77783 11.4365 1.77783 8.00005C1.77783 4.56362 4.56362 1.77783 8.00005 1.77783C11.4365 1.77783 14.2223 4.56362 14.2223 8.00005ZM12.8889 8.00005C12.8889 10.7001 10.7001 12.8889 8.00005 12.8889C5.3 12.8889 3.11117 10.7001 3.11117 8.00005C3.11117 5.3 5.3 3.11117 8.00005 3.11117C10.7001 3.11117 12.8889 5.3 12.8889 8.00005Z",
    fill: "#F89500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15293_10429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDanger);
export default __webpack_public_path__ + "static/media/iconDanger.cdf365c4966fcee37f855c02427a60d8.svg";
export { ForwardRef as ReactComponent };